/**
 * Palmiye Gurme — ürün sayfası (Tur 7b)
 *
 * 1) Konuma göre teslimat tahmini (snippets/pg-pdp-delivery.liquid)
 *    - İl/ilçe listesi + iller arası mesafe: assets/pg-tr-locations.json (ilk ihtiyaçta yüklenir)
 *    - Konum önceliği: tarayıcıda kayıtlı seçim → müşterinin varsayılan adresi → (izin zaten verilmişse)
 *      cihaz konumu. Cihaz konumu yalnızca izin verilmişse ya da "Konumumu kullan"a basılınca okunur.
 *    - Kural (panelden): çıkış iline uzaklık ≤ yakın mesafe → yakın süre; değilse en az–en çok gün.
 *      Teslimat günleri ve kesim saati ayardan; tüm tarihler İstanbul saatine göre.
 *
 * 2) "Şimdi Al" butonu: Shopify'ın hızlı ödeme butonunu (yalnızca bu ürünle ödemeye geçer) tetikler;
 *    buton yoksa ürünü sepete ekleyip ödemeye yönlendirir.
 */
(() => {
  if (window.__pgPdp) return;
  window.__pgPdp = true;

  const ROOT = window.Shopify?.routes?.root || '/';
  const STORE_KEY = 'pg-delivery-location';
  const TZ = 'Europe/Istanbul';

  /* ---------------------------------------------------------- yardımcılar */
  const norm = (v) => String(v || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/\b(ili|ilçesi|province|merkez)\b/g, '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/ı/g, 'i')
    .replace(/[^a-z0-9]/g, '');

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (_) { return null; } },
    set(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (_) { /* gizli sekme */ } },
  };

  let dataPromise = null;
  function loadData(url) {
    if (!dataPromise) dataPromise = fetch(url).then((r) => { if (!r.ok) throw new Error('data'); return r.json(); });
    return dataPromise;
  }

  function todayIst() {
    const p = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    const g = (t) => +p.find((x) => x.type === t).value;
    return { day: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), hour: g('hour') % 24 };
  }
  const addDays = (d, n) => new Date(d.getTime() + n * 86400000);

  /** start gününden SONRA gelen n'inci teslimat günü */
  function nthDeliveryDay(start, n, days) {
    let d = start; let left = Math.max(1, n); let guard = 0;
    while (left > 0 && guard++ < 60) {
      d = addDays(d, 1);
      if (days.has(d.getUTCDay())) left--;
    }
    return d;
  }

  /* ------------------------------------------------------- teslimat kutusu */
  function initEta(box) {
    const ds = box.dataset;
    const modal = box.querySelector('[data-pg-eta-modal]');
    const citySel = box.querySelector('[data-pg-eta-city]');
    const distSel = box.querySelector('[data-pg-eta-district]');
    const msg = box.querySelector('[data-pg-eta-msg]');
    const locateBtn = box.querySelector('[data-pg-eta-locate]');
    const locateLabel = box.querySelector('[data-pg-eta-locate-label]');
    const locateDefault = locateLabel?.textContent || '';
    const days = new Set((ds.days || '1,2,3,4,5,6').split(',').map(Number).filter((x) => x >= 0 && x <= 6));
    const locale = (document.documentElement.lang || 'tr').startsWith('en') ? 'en-GB' : 'tr-TR';
    const fmtLong = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'long', weekday: 'long' });
    const fmtShort = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'long' });
    let data = null;

    const showMsg = (text) => { if (!msg) return; msg.textContent = text || ''; msg.hidden = !text; };

    function cityByName(name) {
      const n = norm(name);
      if (!n || !data) return null;
      return data.cities.find(([, nm]) => norm(nm) === n) || data.cities.find(([, nm]) => n.includes(norm(nm))) || null;
    }
    function districtIn(code, names) {
      const list = data?.districts[code] || [];
      for (const raw of names) {
        const n = norm(raw);
        if (!n) continue;
        const hit = list.find((d) => norm(d) === n);
        if (hit) return hit;
      }
      return '';
    }

    function fillCities(selected) {
      citySel.innerHTML = `<option value="">${citySel.options[0]?.textContent || ''}</option>` +
        data.cities.map(([c, n]) => `<option value="${c}"${c === selected ? ' selected' : ''}>${n}</option>`).join('');
    }
    function fillDistricts(code, selected) {
      const first = distSel.options[0]?.textContent || '';
      const list = data.districts[code] || [];
      distSel.innerHTML = `<option value="">${first}</option>` +
        list.map((d) => `<option value="${d.replace(/"/g, '&quot;')}"${d === selected ? ' selected' : ''}>${d}</option>`).join('');
      distSel.disabled = !list.length;
    }

    function estimate(code) {
      const origin = (ds.origin || '34').padStart(2, '0');
      const km = code === origin ? 0 : (data.km[origin]?.[code] ?? data.km[code]?.[origin] ?? Infinity);
      const near = km <= (Number(ds.nearKm) || 0);
      const { day: today, hour } = todayIst();
      const cutoff = Number(ds.cutoff) || 0;
      const start = cutoff > 0 && hour >= cutoff ? addDays(today, 1) : today;
      if (near) {
        const d = nthDeliveryDay(start, Number(ds.nearDays) || 1, days);
        if (d.getTime() === addDays(today, 1).getTime()) return ds.tTomorrow;
        return ds.tOn.replace('%DATE%', fmtLong.format(d));
      }
      const a = nthDeliveryDay(start, Number(ds.farMin) || 2, days);
      const b = nthDeliveryDay(start, Math.max(Number(ds.farMin) || 2, Number(ds.farMax) || 3), days);
      if (a.getTime() === b.getTime()) return ds.tOn.replace('%DATE%', fmtLong.format(a));
      return ds.tRange.replace('%FROM%', fmtShort.format(a)).replace('%TO%', fmtLong.format(b));
    }

    function render(loc) {
      const place = box.querySelector('[data-pg-eta-place]');
      const result = box.querySelector('[data-pg-eta-result]');
      const text = box.querySelector('[data-pg-eta-text]');
      const changeLabel = box.querySelector('[data-pg-eta-change-label]');
      if (!loc || !data) return;
      const city = data.cities.find(([c]) => c === loc.code);
      if (!city) return;
      place.textContent = loc.district ? `${city[1]}, ${loc.district}` : city[1];
      place.classList.add('is-set');
      changeLabel.textContent = ds.tChange;
      text.innerHTML = estimate(loc.code);
      result.hidden = false;
    }

    async function ensureData() {
      if (data) return data;
      data = await loadData(ds.src);
      return data;
    }

    async function reverseGeocode(lat, lon) {
      const url = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=tr`;
      const r = await fetch(url);
      if (!r.ok) throw new Error('geo');
      const j = await r.json();
      const admins = (j.localityInfo?.administrative || []).map((a) => a.name);
      const city = cityByName(j.principalSubdivision) || admins.map(cityByName).find(Boolean);
      if (!city) return null;
      const district = districtIn(city[0], [j.city, j.locality, ...admins]);
      return { code: city[0], district };
    }

    function locate(silent) {
      return new Promise((resolve) => {
        if (!navigator.geolocation) { resolve(null); return; }
        if (!silent && locateLabel) locateLabel.textContent = ds.tLocating;
        navigator.geolocation.getCurrentPosition(async (pos) => {
          try {
            await ensureData();
            resolve(await reverseGeocode(pos.coords.latitude.toFixed(4), pos.coords.longitude.toFixed(4)));
          } catch (_) { resolve(null); }
        }, (err) => {
          if (!silent) showMsg(err && err.code === 1 ? ds.tDenied : ds.tFail);
          resolve(null);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      }).finally(() => { if (locateLabel) locateLabel.textContent = locateDefault; });
    }

    function save(loc) { store.set(loc); document.querySelectorAll('[data-pg-eta]').forEach((b) => b.__pgRender?.(loc)); }
    box.__pgRender = render;

    /* başlangıç: kayıtlı → müşteri adresi → izinli konum */
    (async () => {
      const saved = store.get();
      try { await ensureData(); } catch (_) { return; }
      if (saved?.code) { render(saved); return; }
      if (ds.custCity) {
        const c = cityByName(ds.custCity);
        if (c) { const loc = { code: c[0], district: districtIn(c[0], [ds.custDistrict]) }; render(loc); return; }
      }
      try {
        const perm = await navigator.permissions?.query({ name: 'geolocation' });
        if (perm?.state === 'granted') {
          const loc = await locate(true);
          if (loc) { save(loc); }
        }
      } catch (_) { /* permissions API yok */ }
    })();

    /* pencere */
    box.querySelector('[data-pg-eta-open]')?.addEventListener('click', async () => {
      showMsg('');
      try { await ensureData(); } catch (_) { showMsg(ds.tFail); }
      const cur = store.get() || {};
      if (data) { fillCities(cur.code || ''); if (cur.code) fillDistricts(cur.code, cur.district || ''); }
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      citySel.focus();
    });
    const close = () => { if (modal.open) modal.close(); else modal.removeAttribute('open'); };
    box.querySelector('[data-pg-eta-close]')?.addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    citySel.addEventListener('change', () => { showMsg(''); fillDistricts(citySel.value, ''); });
    locateBtn?.addEventListener('click', async () => {
      showMsg('');
      const loc = await locate(false);
      if (!loc) { if (msg?.hidden) showMsg(ds.tFail); return; }
      fillCities(loc.code); fillDistricts(loc.code, loc.district);
    });
    box.querySelector('[data-pg-eta-apply]')?.addEventListener('click', () => {
      if (!citySel.value) { showMsg(ds.tNeedCity); citySel.focus(); return; }
      save({ code: citySel.value, district: distSel.value || '' });
      close();
    });
  }

  /* ------------------------------------------------------------ Şimdi Al */
  function initBuyNow(btn) {
    const form = document.getElementById(btn.dataset.form);
    const submit = form?.querySelector('[type="submit"][name="add"]');
    // Sepete Ekle devre dışıysa (stok yok / seçenek seçilmedi) Şimdi Al da devre dışı
    if (submit) {
      const sync = () => { btn.disabled = submit.disabled || submit.hasAttribute('disabled'); };
      sync();
      new MutationObserver(sync).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    }
    btn.addEventListener('click', async () => {
      const scope = btn.closest('form, section, .shopify-section') || document;
      const native = scope.querySelector('[data-pg-dynamic-checkout] .shopify-payment-button__button:not([disabled])');
      if (native) { native.click(); return; }
      if (!form) return;
      btn.disabled = true;
      try {
        const res = await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) throw new Error('add');
        window.location.href = `${ROOT}checkout`;
      } catch (_) {
        btn.disabled = false;
        submit?.click(); // hata mesajını temanın kendi akışı göstersin
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-pg-eta]').forEach((b) => { if (!b.__pgInit) { b.__pgInit = true; initEta(b); } });
    document.querySelectorAll('[data-pg-buy-now]').forEach((b) => { if (!b.__pgInit) { b.__pgInit = true; initBuyNow(b); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  // Varyant değişince Kalles satın alma alanını yeniden çizebilir → yeni butonu bağla
  document.addEventListener('variant:update', () => setTimeout(init, 50));
  // Kısa açıklama → "Devamını oku": ürün açıklaması akordeonunu açar ve oraya kaydırır
  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-pg-read-more]');
    if (!more) return;
    const scope = more.closest('.pg-bup-main-product') || document;
    const acc = scope.querySelector('.pg-bup-product-description');
    if (!acc) return;
    const trigger = acc.querySelector('.pg-bup-accordion__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    acc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    trigger?.focus({ preventScroll: true });
  });
  // Aralıklı gramaj notu (snippets/pg-range-note.liquid): Kalles varyant değişince formdan 'variant:change' yayar
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    const root = (e.target.closest && e.target.closest('.pg-bup-main-product')) || document;
    const note = root.querySelector('[data-pg-range-note]');
    const mapEl = root.querySelector('[data-pg-range-map]');
    if (!note || !mapEl) return;
    let map = {};
    try { map = JSON.parse(mapEl.textContent || '{}'); } catch (err) { return; }
    const text = map[String(variant.id)];
    note.hidden = !text;
    if (text) note.querySelector('[data-pg-range-note-text]').textContent = text;
  });
  /* Tur 12 — kg fiyatı + seçili gramajın okunur etiketi ("100" → "100 g").
     Veri gramaj düğmelerinin data-pg-opt-* özniteliklerinde (snippets/product-variant-options.liquid). */
  function syncUnit(root) {
    const scope = root || document;
    scope.querySelectorAll('.pg-bup-main-product').forEach((sec) => {
      const out = sec.querySelector('[data-pg-unit-price]');
      const checked = sec.querySelector('.pg-bup-variant-picker input[type="radio"]:checked');
      const label = checked && sec.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
      if (label && label.dataset.pgOptLabel) {
        const cur = checked.closest('[data-pg-option]')?.querySelector('[update-value]');
        if (cur) cur.textContent = label.dataset.pgOptLabel;
      }
      if (!out) return;
      const perkg = label && label.dataset.pgOptPerkg;
      if (perkg) { out.textContent = perkg; out.hidden = false; out.classList.remove('is-hint'); }
      else if (!checked && out.dataset.pgUnitHint) { out.textContent = out.dataset.pgUnitHint; out.hidden = false; out.classList.add('is-hint'); }
      else { out.textContent = ''; out.hidden = true; }
    });
  }
  document.addEventListener("variant:change", () => setTimeout(syncUnit, 60));
  document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('.pg-bup-variant-picker')) setTimeout(syncUnit, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncUnit()); else syncUnit();

  // Puan özeti → yorumlar bölümü (Judge.me veya sayfadaki ilk yorum alanı)
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('[data-pg-reviews-link]');
    if (!link) return;
    const target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget, [id*="review" i]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  // Seçenek başlığı: seçim yapılınca "Gramaj seçin" → "Gramaj: 80-100"
  document.addEventListener('change', (e) => {
    const fs = e.target.closest && e.target.closest('[data-pg-option]');
    if (fs && e.target.matches('input[type="radio"]')) fs.classList.add('has-value');
  });
  // Galeri okları seçili görselin sağ alt köşesine oturur: görselin ana kutuya göre boşluğu px olarak nav'a yazılır
  function placeNav(main) {
    const nav = main.querySelector('.pg-bup-product-media__nav');
    const media = main.querySelector('.hdt-slider__slide.is-selected .hdt-product__media') || main.querySelector('.hdt-product__media');
    if (!nav || !media) return;
    const m = main.getBoundingClientRect();
    const r = media.getBoundingClientRect();
    if (!r.width) return;
    // Yatay boşluk slayta göre ölçülür (kaydırma animasyonu sırasında da doğru), dikey boşluk ana kutuya göre
    const slide = media.closest('.hdt-slider__slide');
    const sr = slide ? slide.getBoundingClientRect() : m;
    nav.style.setProperty('--pg-nav-r', Math.max(0, Math.round(m.width - (r.right - sr.left))) + 'px');
    nav.style.setProperty('--pg-nav-b', Math.max(0, Math.round(m.bottom - r.bottom)) + 'px');
  }
  function syncNavRatio(root) {
    (root || document).querySelectorAll('.pg-bup-product-media__main').forEach((main) => {
      if (!main.querySelector('.pg-bup-product-media__nav')) return;
      placeNav(main);
      if (main.dataset.pgNavObs) return;
      main.dataset.pgNavObs = '1';
      let raf = 0;
      const queue = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => placeNav(main)); };
      const box = main.querySelector('.hdt-slider__container');
      if (box) new MutationObserver(queue).observe(box, { subtree: true, attributes: true, attributeFilter: ['class'] });
      if ('ResizeObserver' in window) new ResizeObserver(queue).observe(main);
      main.addEventListener('load', queue, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncNavRatio()); else syncNavRatio();
  document.addEventListener('shopify:section:load', (e) => syncNavRatio(e.target));
})();
